import React, { useMemo, FC }            from 'react';
import { TDataTableRow }                 from '@typings/components';
import { IInvoiceHistory }               from '@typings/invoiceManagement';
import { EAppPage }                      from '@enums/common';
import { EInvoicePage }                  from '@enums/invoiceManagement';
import { MONTH_SHORTNAME_BY_NUMBER }     from '@utils/suggestions';
import {
  formatCurrency,
  multiFieldSorter,
}                                        from '@utils/commonFunctions';
import { INVOICE_HISTORY_TABLE_HEADERS } from '@modules/invoiceManagement/utils/tableHeaders';
import {
  DataTable,
  LinkButton,
}                                        from '@components/index';

const getTableRows  = (
  invoiceHistory : IInvoiceHistory[],
  push           : (path: string) => void,
): TDataTableRow[] =>
  invoiceHistory
    .sort(multiFieldSorter(['-year', '-month']))
    .map((item: IInvoiceHistory): TDataTableRow => [
      {
        value: (
          <LinkButton
            label   = {`${MONTH_SHORTNAME_BY_NUMBER[item.month]} ${item.year}`}
            onClick = {() => push(`${EAppPage.InvoiceManagement}/${EInvoicePage.Monthly}?${item.year}-${item.month}`)}
          />
        ),
      },

      {
        value : formatCurrency(item.invoiceAmount) ?? 0,
        align : 'right',
      },

      {
        value : formatCurrency(item.paidAmount) ?? 0,
        align : 'right',
      },
    ]);

interface IProp {
  invoiceHistory : IInvoiceHistory[];
  isLoading      : boolean;
  push           : (path: string) => void;
}

export const InvoiceHistoryPage: FC<IProp> = ({
  invoiceHistory,
  isLoading,
  push,
}) => {
  const historyRows = useMemo(
    (): TDataTableRow [] => getTableRows(invoiceHistory, push),
    [invoiceHistory, push],
  );

  return (
    <DataTable
      headers  = {INVOICE_HISTORY_TABLE_HEADERS}
      rows     = {historyRows}
      loading  = {isLoading}
      maxwidth = "500px"
      margin   = "20px 30px"
    />
  );
};
